import { Skeleton } from '@/common/components/ui/skeleton';
import { cn } from '@/lib/utils';

export const OrgTabListSkeleton = () => (
  <div className="space-y-4">
    <div className="flex items-center justify-between">
      <Skeleton className="h-5 w-20" />
      <Skeleton className="h-9 w-[130px]" />
    </div>
    <div className="rounded-2xl border border-border overflow-hidden bg-card">
      <div className="border-b border-border px-5 py-3 bg-muted/50">
        <Skeleton className="h-3 w-[220px]" />
      </div>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className={cn('flex items-center gap-4 px-5 py-4', i < 2 && 'border-b border-border')}
        >
          <Skeleton className="size-8 rounded-full shrink-0" />
          <div className="flex-1 flex flex-col gap-1.5">
            <Skeleton className="h-4 w-[180px]" />
            <Skeleton className="h-3 w-[140px]" />
          </div>
          <Skeleton className="h-8 w-24 hidden sm:block" />
        </div>
      ))}
    </div>
  </div>
);
